import React, {useState, useEffect, useContext} from 'react';
import {Input, Table, Button} from 'reactstrap';
import Loader from 'components/Loader';
import PaginationWrapper from 'components/PaginationWrapper';
import sortAlphabetically from 'Helpers/sortAlphabetically';
import {sortByValue} from 'Helpers/sortByValue';
import {ErrorContext} from 'contexts/ErrorContext';
import SortableTableHeader from 'components/SortableTableHeader';
import {checkPermissions} from 'utils/other';
import UserListItem from './UserListItem';
import {useHistory} from 'react-router-dom';
import {connect} from 'react-redux';
import {getUsers} from 'utils/api/usersApi';
import {getSavedSearches} from 'utils/api/savedSearchesApi';
import {getEntities} from 'utils/api/entitiesApi';
import AddUserModal from './modals/AddUserModal';
import './style.scss';

const Users = ({auth}) => {
    let history = useHistory();
    const {handleErrors} = useContext(ErrorContext);

    const [searchValue, setSearchValue] = useState('');
    const [fullUsersList, setFullUsersList] = useState(null);
    const [visibleList, setVisibleList] = useState(null);
    const [activeSortProperty, setActiveSortProperty] = useState('name');
    const [activeSortDirection, setActiveSortDirection] = useState('asc');
    const [fetchingData, setFetchingData] = useState(true);
    const [currentPageNumber, setCurrentPageNumber] = useState(1);
    const [activeMobileSortSelection, setActiveMobileSortSelection] = useState('name-asc');
    const [searchesList, setSearchesList] = useState(null);
    const [addUserModalOpen, setAddUserModalOpen] = useState(false);
    const [showNudgeColumn, setShowNudgeColumn] = useState(false);
    const [usersWithNudgePermissions, setUsersWithNudgePermissions] = useState([]);
    const [fullEntitiesList, setFullEntitiesList] = useState(false);
    const [entitiesLoading, setEntitiesLoading] = useState(true);

    useEffect(() => {
        fetchUsersList();
        fetchEntitiesList();
        checkPermissions(auth.permissions, getSavedSearchesList, 'search');
    }, []);


    useEffect(() => {
        if(fullUsersList && visibleList) {
            applyFilters(true, fullUsersList);
        }
    }, [activeSortProperty, activeSortDirection, searchValue]);

    const applyFilters = (resetPage, list) => {
        let newArr = sortByValue(list, activeSortProperty, activeSortDirection);
        if(searchValue && searchValue.length > 0) {
            let arrFilteredBySearchValue = newArr.filter(item => {
                return item.name.toLowerCase().includes(searchValue.toLowerCase()) || item.email.toLowerCase().includes(searchValue.toLowerCase());
            });
            setVisibleList(arrFilteredBySearchValue);
            resetPage && setCurrentPageNumber(1);
        } else {
            setVisibleList(newArr);
            resetPage && setCurrentPageNumber(1);
        }
    };

    const fetchUsersList = async(refresh) => {
        try {
            !fetchingData && !refresh && setFetchingData(true);
            let data = await getUsers();
            let nudgeUserData = await getUsers(true);
            if(nudgeUserData.content.result.length > 0) {
                setShowNudgeColumn(true);
                setUsersWithNudgePermissions(nudgeUserData.content.result.map(item => item.id))
            } else {
                setShowNudgeColumn(false);
            }
            let initialList = sortByValue(data.content.result, 'name', 'asc');
            setFullUsersList(initialList);
            if(!refresh) {
                setVisibleList(initialList);
                // setVisibleList(dataArr.filter((item) => item.attachedAccounts.name.toLowerCase().includes(searchValue.toLowerCase())));
            }
            refresh && applyFilters(!refresh, initialList);
            setFetchingData(false);
        } catch(err) {
            console.log(err);
            handleErrors(err);
            setFetchingData(false);
        }
    };

    const fetchEntitiesList = async() => {
        try {
            let entityData = await getEntities();
            setFullEntitiesList(entityData.content.result);
            setEntitiesLoading(false);
        } catch(err) {
            console.log(err);
            handleErrors(err);
            setEntitiesLoading(false);
        }
    };

    const getSavedSearchesList = () => {
        getSavedSearches()
            .then((data) => {
                Array.isArray(data.content.result) && setSearchesList(data.content.result.sort((a, b) => a.sourceName.localeCompare(b.sourceName)));
            })
            .catch((err) => {
                handleErrors(err);
                console.log(err);
            });
    };

    const handlePaginationClick = (pageNumber) => {
        setCurrentPageNumber(pageNumber.selected + 1);
    };

    const handleSortSelect = (sortValue) => {
        if(activeSortProperty === sortValue) {
            setActiveSortDirection(activeSortDirection === 'asc' ? 'desc' : 'asc');
        } else {
            setActiveSortProperty(sortValue);
            setActiveSortDirection('asc');
        }
    };

    const handleMobileSortSelect = (sortSelection) => {
        let splitArr = sortSelection.split('-');
        if(splitArr.length === 2) {
            setActiveSortProperty(splitArr[0]);
            setActiveSortDirection(splitArr[1]);
        }
        setActiveMobileSortSelection(sortSelection);
    };


    const toggleAddUserModal = () => setAddUserModalOpen(prevState => !prevState);

    return (
        <div className="mt-3 w-100" style={{padding: '0 30px'}}>
            {addUserModalOpen && (
                <AddUserModal
                    isOpen={addUserModalOpen}
                    toggle={toggleAddUserModal}
                    refreshList={fetchUsersList}
                />
            )}
            <div className="d-flex align-items-center flex-column">
                <div className="w-100">
                    <div className="fetches__header mt-3 mb-3 d-flex justify-content-between align-items-center">
                        <h1 className="mb-0">Users</h1>
                    </div>
                    {visibleList === null ? (
                        <Loader small text="Fetching user data"/>
                    ) : (
                        <>
                            <div className="d-flex align-items-center justify-content-between mb-3">
                                <div className="feeds-container_input flex-grow-1">
                                    {fullUsersList !== null && fullUsersList.length > 0 && (
                                        <div className="feeds-container-wrapper mb-0">
                                            <Input
                                                style={{height: '35px'}}
                                                onChange={(e) => setSearchValue(e.target.value)}
                                                value={searchValue}
                                                placeholder="Search by user name or email"
                                                type="text"
                                                name="usersSearchValue"
                                                className="searchInput"
                                                id="usersSearchValue"
                                                autoComplete="off"
                                            />
                                            {!searchValue ? (
                                                <i
                                                    style={{
                                                        position: 'absolute',
                                                        top: '28%',
                                                        bottom: '10.5px',
                                                        right: '11px',
                                                    }}
                                                    className="fa fa-search search-container_icon"
                                                />
                                            ) : (
                                                <i
                                                    style={{
                                                        cursor: 'pointer',
                                                        position: 'absolute',
                                                        top: '28%',
                                                        bottom: '10.5px',
                                                        right: '11px',
                                                    }}
                                                    onClick={() => setSearchValue('')}
                                                    className="fa fa-times-circle search-container_icon"
                                                />
                                            )}
                                        </div>
                                    )}
                                </div>
                                <div>
                                    {auth.permissions && (auth.permissions.includes('user')) &&
                                        <Button
                                            className="calltoaction-button ml-2"
                                            style={{color: 'white'}}
                                            onClick={toggleAddUserModal}
                                        >
                                            Add User
                                        </Button>
                                    }
                                </div>
                            </div>
                            {fullUsersList && fullUsersList.length > 0 && (
                                <div className="feeds_sortBy">
                                    <span>Sort by</span>
                                    <Input onChange={(e) => handleMobileSortSelect(e.target.value)} type="select"
                                           value={activeMobileSortSelection}>
                                        <option value="name-asc">User (A to Z)</option>
                                        <option value="name-desc">User (Z to A)</option>
                                        <option value="email-asc">User (A to Z)</option>
                                        <option value="email-desc">User (Z to A)</option>
                                        <option value="isAdministrator-desc">Admin ('Yes' first)</option>
                                        <option value="isAdministrator-asc">Admin ('No' first)</option>
                                        <option value="enabled-desc">Confirmed ('Yes' first)</option>
                                        <option value="enabled-asc">Confirmed ('No' first)</option>
                                        {/*<option value="timezone-asc">Timezone (A to Z)</option>*/}
                                        {/*<option value="timezone-desc">Timezone(Z to A)</option>*/}
                                        {/*<option value="userTZ">User's TZ (A to Z)</option>*/}
                                        {/*<option value="userTZDescending">User's TZ (Z to A)</option>*/}
                                        {/*<option value="createdAt-desc">Created at (Newest to Oldest)</option>*/}
                                        {/*<option value="createdAt-asc">Created at (Oldest to Newest)</option>*/}
                                        {/*<option value="feedscount">Feeds Count (1 to 9)</option>*/}
                                        {/*<option value="feedscountDescending">Feeds Count (9 to 1)</option>*/}
                                    </Input>
                                </div>
                            )}
                            {/* <div>
                            <Button className="typical-button" style={{ color: 'white' }} onClick={() => reactivateFacebook(true)}>
                                Reactivate Facebook Accounts
                            </Button>
                        </div> */}
                            <div className="table mt-3">
                                {fullUsersList && fullUsersList.length > 0 ? (
                                    <Table style={{color: '#314784'}} responsive>
                                        <thead className="hidden">
                                        <tr>
                                            <SortableTableHeader
                                                name="Name"
                                                value="name"
                                                activeSortValue={activeSortProperty}
                                                activeSortDirection={activeSortDirection}
                                                handleSelect={() => handleSortSelect('name')}
                                            />
                                            <SortableTableHeader
                                                name="Email"
                                                value="email"
                                                activeSortValue={activeSortProperty}
                                                activeSortDirection={activeSortDirection}
                                                handleSelect={() => handleSortSelect('email')}
                                            />
                                            <SortableTableHeader
                                                name="Admin"
                                                value="isAdministrator"
                                                activeSortValue={activeSortProperty}
                                                activeSortDirection={activeSortDirection}
                                                handleSelect={() => handleSortSelect('isAdministrator')}
                                            />
                                            <SortableTableHeader
                                                name="Confirmed"
                                                value="enabled"
                                                activeSortValue={activeSortProperty}
                                                activeSortDirection={activeSortDirection}
                                                handleSelect={() => handleSortSelect('enabled')}
                                            />
                                            {auth.permissions && auth.permissions.includes('search') &&
                                            <th>Daily Digest</th>
                                            }
                                            {auth.permissions && auth.permissions.includes('search') &&
                                            <th>Real Time Alerts</th>
                                            }
                                            {showNudgeColumn &&
                                            <th>Nudge Email</th>
                                            }
                                            <th>Actions</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {fetchingData ? (
                                            <tr>
                                                <td className="mt-5"><Loader/></td>
                                            </tr>
                                        ) : (
                                            <>
                                                {visibleList && visibleList.length > 0 ? (
                                                    visibleList.slice((currentPageNumber - 1) * 50, currentPageNumber * 50).map((item, index) => (
                                                        <UserListItem
                                                            key={item.id}
                                                            item={item}
                                                            refreshList={fetchUsersList}
                                                            auth={auth}
                                                            savedSearches={searchesList}
                                                            showNudgeColumn={showNudgeColumn}
                                                            fullEntitiesList={fullEntitiesList}
                                                            entitiesLoading={entitiesLoading}
                                                            hasNudgePermissions={usersWithNudgePermissions.includes(item.id)}
                                                        />
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td className="mt-5">No matching results</td>
                                                    </tr>
                                                )}
                                            </>
                                        )}
                                        </tbody>
                                    </Table>
                                ) : (
                                    <p className="mt-5">Add users to manage them here</p>
                                )}
                            </div>
                            {visibleList && visibleList.length > 50 && (
                                <PaginationWrapper
                                    totalPages={Math.ceil(visibleList.length / 50)}
                                    handlePageClick={handlePaginationClick}
                                />
                            )}
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

const mapStateFromProps = (state) => ({
    auth: state.auth,
});

export default connect(mapStateFromProps, null)(Users);
